const state = {
  modelInfo: null,
  tabs: [
    {
      tab: "Window",
      content: {
        img:
          "https://zdnet2.cbsistatic.com/hub/i/r/2018/11/12/a61a73c0-ff03-439c-b041-9e50e9d0f08e/resize/1200x900/ca9aabfd6f85c4baa7cc44a04b8a1224/dynamic-glass.png"
      }
    },
    {
      tab: "Building Elevation",
      content: {
        img:
          "https://zdnet2.cbsistatic.com/hub/i/r/2018/11/12/a61a73c0-ff03-439c-b041-9e50e9d0f08e/resize/1200x900/ca9aabfd6f85c4baa7cc44a04b8a1224/dynamic-glass.png"
      }
    },
    {
      tab: "Floor Plans",
      content: {
        img:
          "https://zdnet2.cbsistatic.com/hub/i/r/2018/11/12/a61a73c0-ff03-439c-b041-9e50e9d0f08e/resize/1200x900/ca9aabfd6f85c4baa7cc44a04b8a1224/dynamic-glass.png"
      }
    },
    {
      tab: "Configurator",
      content: {
        img:
          "https://zdnet2.cbsistatic.com/hub/i/r/2018/11/12/a61a73c0-ff03-439c-b041-9e50e9d0f08e/resize/1200x900/ca9aabfd6f85c4baa7cc44a04b8a1224/dynamic-glass.png"
      }
    }
  ]
};

const getters = {
  tabs: state => state.tabs,
  modelInfo: state => state.modelInfo
};

const mutations = {
  setModelInfo: (state, payload) => {
    state.modelInfo = payload;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
